import React from 'react';
import TermItemSelectField from '../../../../Term/Components/TermItemSelectField';
import { BaseFieldProps } from '../../Inputs/BaseField/BaseField';

const P1ProceduresField: React.FC<BaseFieldProps> = props => {
	return <TermItemSelectField {...props} termType='p1_idc9_procedures' />;
};

export default P1ProceduresField;
